import { IconType } from "react-icons";
import {
  FaFilePdf,
  FaFileExcel,
  FaFileAlt,
  FaFileImage,
  FaFile,
  FaFileWord,
} from "react-icons/fa";

export const formatFileSize = (bytes: number): string => {
  if (!Number.isFinite(bytes) || bytes <= 0) return "0 Bytes";
  const k = 1024;
  const sizes = ["Bytes", "KB", "MB"];
  const i = Math.min(
    Math.floor(Math.log(bytes) / Math.log(k)),
    sizes.length - 1
  );
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
};

export const isImage = (contentType: string): boolean => {
  return contentType.startsWith("image/");
};

export const getFileIcon = (
  contentType: string,
  filename?: string
): { icon: IconType; color: string } => {
  if (isImage(contentType)) {
    return { icon: FaFileImage, color: "green.500" };
  }

  if (contentType === "application/pdf") {
    return { icon: FaFilePdf, color: "red.500" };
  }

  if (
    contentType.includes("word") ||
    filename?.toLowerCase().endsWith(".doc") ||
    filename?.toLowerCase().endsWith(".docx")
  ) {
    return { icon: FaFileWord, color: "blue.500" };
  }

  if (
    contentType.includes("sheet") ||
    contentType.includes("excel") ||
    filename?.toLowerCase().endsWith(".xls") ||
    filename?.toLowerCase().endsWith(".xlsx") ||
    filename?.toLowerCase().endsWith(".csv")
  ) {
    return { icon: FaFileExcel, color: "green.600" };
  }

  if (
    contentType.includes("text") ||
    filename?.toLowerCase().endsWith(".txt")
  ) {
    return { icon: FaFileAlt, color: "gray.500" };
  }

  return { icon: FaFile, color: "gray.400" };
};

export const downloadMediaFile = async (media: any): Promise<void> => {
  try {
    const url = await media.getContentTemporaryUrl();
    if (url) {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Download failed with status ${response.status}`);
      }
      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = media.filename || "download";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
    }
  } catch (error) {
    console.error("Failed to download file:", error);
  }
};
